<template>
  <div class="detail-container">
    <div class="header">
      <div class="color-line1"></div>
      <div class="color-line2"></div>
      <p class="total">相关结果约 <span>{{ pageInfo.total }}</span> 条</p>
    </div>
    <div class="box-item">
      <div class="box-header">
        <p class="title">{{ title }}</p>
      </div>
      <info v-if="this.name ==='info'" :list="list" ></info>
      <teacher-model v-if="this.name ==='teacher'" :list="list"></teacher-model>
      <class-model v-if="this.name ==='class'" :list="list"></class-model>
      <el-pagination
        @size-change="handleChangeSize"
        @current-change="handleChangeCurrent"
        :current-page="pageInfo.current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Info from './components/info'
import TeacherModel from './components/teacher'
import ClassModel from './components/class'
import { informationEs, teacherEs, queryClassEs } from '@/api/search'
export default {
  components: {
    Info,
    TeacherModel,
    ClassModel
  },
  data() {
    return {
      pageInfo: {
        current: 1,
        pageSize: 20,
        total: 0
      },
      list: []
    }
  },
  computed: {
    searchValue() {
      return this.$route.query.searchValue
    },
    name() {
      return this.$route.query.name
    },
    title() {
      let name = ''
      if (this.name === 'info') {
        name = '资讯'
      } else if (this.name === 'teacher') {
        name = '名师风采'
      } else {
        name = '面授培训'
      }
      return name
    }
  },
  mounted() {
    if (this.name === 'info') {
      this.getInfo(this.searchValue, 1, 10)
    } else if (this.name === 'teacher') {
      this.getTeacher(this.searchValue, 1, 10)
    } else {
      this.getClass(this.searchValue, 1, 10)
    }
  },
  methods: {
    // 改变条数
    handleChangeSize(val) {
      if (this.name === 'info') {
        this.getInfo(this.searchValue, this.pageInfo.current, val)
      } else if (this.name === 'teacher') {
        this.getTeacher(this.searchValue, this.pageInfo.current, val)
      } else {
        this.getClass(this.searchValue, this.pageInfo.current, val)
      }
    },
    // 改变当前页
    handleChangeCurrent(val) {
      if (this.name === 'info') {
        this.getInfo(this.searchValue, val, this.pageInfo.pageSize)
      } else if (this.name === 'teacher') {
        this.getTeacher(this.searchValue, val, this.pageInfo.pageSize)
      } else {
        this.getClass(this.searchValue, val, this.pageInfo.pageSize)
      }
    },
    getInfo(name, page, limit) {
      informationEs({
        name,
        page,
        limit
      }).then(res => {
        const { code, data } = res
        if (code === 0) {
          this.pageInfo = {
            ...this.pageInfo,
            total: Number(data.totalElements)
          }
          if (data.content.length > 0) {
            this.list = data.content
          }
        }
      })
    },
    // 获取名师列表
    getTeacher(name, page, limit) {
      teacherEs({
        name,
        page,
        limit
      }).then(res => {
        const { code, data } = res
        if (code === 0) {
          this.pageInfo = {
            ...this.pageInfo,
            total: Number(data.totalElements)
          }
          if (data.content.length > 0) {
            this.list = data.content
          }
        }
      })
    },
    // 获取面授培训列表
    getClass(name, page, limit) {
      queryClassEs({
        name,
        page,
        limit
      }).then(res => {
        const { code, data } = res
        console.log('class', data)
        if (code === 0) {
          this.pageInfo = {
            ...this.pageInfo,
            total: Number(data.totalElements)
          }
          if (data.content.length > 0) {
            this.list = data.content
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-container {
  max-width: 1300px;
  margin: 30px auto 40px;
  background-color: #fff;
  box-shadow: 0px 1px 13px 0px rgba(0, 0, 0, 0.08);
  padding: 0 0 140px;
  .header {
    height: 54px;
    padding: 0 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: linear-gradient(0deg, #ffffff 0%, #eaeaea 100%);
    position: relative;
    box-sizing: border-box;
    .color-line1 {
      position: absolute;
      box-sizing: border-box;
      width: calc(100% - 36px);
      height: 2px;
      background: rgba($color: #085dc8, $alpha: 0.35);
      top: 0;
      left: 0;
      margin: 0 18px;
    }
    .color-line2 {
      position: absolute;
      width: 128px;
      height: 4px;
      background: #ff4e4e;
      top: 0;
      left: 18px;
    }
    .total {
      color: #333;
      font-size: 14px;
      font-weight: bold;
      span {
        color: #FF4E4E;
      }
    }
  }
  .box-item {
    margin-top: 20px;
    padding: 0 58px;
    .box-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 2px solid rgba(8, 93, 200, .3);
      .title {
        width: 70px;
        color: #333;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        position: relative;
        &::before {
          content: '·';
          display: inline;
          font-size: 20px;
          color: #D00D0D;
        }
        &::after {
          content: '';
          display: inline-block;
          width: 70px;
          height: 4px;
          background-color: #FF4E4E;
          border-radius: 2px;
          position: absolute;
          bottom: -2px;
          left: 0;
          text-align: center;
        }
      }
      .more {
        color: #333;
        font-size: 14px;
        display: flex;
        align-items: center;
        cursor: pointer;
        img {
          height: 18px;
          margin-left: 5px;
        }
      }
    }
  }
  .no-data {
    width: 304px;
    margin: 90px auto 0;
    text-align: center;
    img {
      margin-bottom: 30px;
    }
    p {
      color: #999;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
    }
    .left {
      text-align: left;
      margin: 15px 40px;
    }
  }
  ::v-deep .el-pagination {
    text-align: center;
    margin-top: 50px;
    .el-pagination__total {
      color: #333;
    }
    .el-input__inner, .el-pager li.active {
      color: #333;
      background-color: rgba(10, 101, 219, 0.22);
      border: 1px solid #0753B6;
    }
    .el-pager li.active {
      color: #0753B6;
      border-radius: 5px;
    }
    span {
      color: #333;
    }
  }
}
</style>
